import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ResourceBundleService } from '@app/services/resource-bundle/resource-bundle.service';
import { get } from 'lodash-es';

@Component({
    selector: 'pixie-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HeroComponent implements OnInit {
    @Input() id: string;
    @Input() titleMobile: any;
    @Input() titleDesktop: any;
    @Input() ctasMobile: object[];
    @Input() ctasDesktop: object[];
    @Input() src: any;
    @Input() fullscreen: boolean;
    @Input() ME: any;
    @Input() dataType: string;

    constructor(private sanitizer: DomSanitizer, private resourceBundle: ResourceBundleService) { }

    ngOnInit() {
        this.ctasMobile = [
            {
                alt: '',
                analyticsLinkId: '',
                title: '',
            },
            {
                alt: '',
                analyticsLinkId: '',
                title: '',
                ctaURL: '',
            },
        ];
        this.ctasDesktop = [
            {
                alt: '',
                analyticsLinkId: '',
                title: '',
            },
            {
                alt: '',
                analyticsLinkId: '',
                analyticsLinkIdFullscreen: '',
                title: '',
                ctaURL: '',
            },
        ];
        this.resourceBundle.get('heroes').then(data => {
            if (get(data, 'heroes[0].descriptions.defaultImage.sections.source', false)
            && data.heroes[0].descriptions.defaultImage.sections.source.length > 1) {
                this.dataType = 'image';
                this.titleMobile = data.heroes[0].descriptions.mobileDefaultImage.sections.alt;
                this.ctasMobile = [
                    {
                        alt: '',
                        analyticsLinkId: '',
                        title: '',
                    },
                    {
                        alt: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.alt,
                        analyticsLinkId: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.analyticsLinkId,
                        title: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.title,
                        ctaURL: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.ctaURL,
                    }
                ];
                this.titleDesktop = data.heroes[0].descriptions.defaultImage.sections.alt;
                this.ctasDesktop = [
                    {
                        alt: '',
                        analyticsLinkId: '',
                        title: '',
                    },
                    {
                        alt: data.heroes[0].descriptions.videoDetailsCTA.sections.alt,
                        analyticsLinkId: 'DCL_HPMP_Billboard_' +
                            data.heroes[0].descriptions.videoDetailsCTA.sections.analyticsLinkId +
                            '_Link',
                        analyticsLinkIdFullscreen: 'DCL_HPMP_InVideo_' +
                            data.heroes[0].descriptions.videoDetailsCTA.sections.analyticsLinkId +
                            '_Link',
                        title: data.heroes[0].descriptions.videoDetailsCTA.sections.title,
                        ctaURL: data.heroes[0].descriptions.videoDetailsCTA.sections.ctaURL,
                    }
                ];

                // This gets used from within the frame
                window['heroMedia'] = [{
                    type: 'image',
                    thumbnail: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    source: [
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ],
                    preview: [
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ],
                    poster: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    title: 'DCL',
                    alt: 'DCL',
                    tags: ['a']
                }];
            } else if (get(data, 'heroes[0].descriptions', false)) {
                this.titleMobile = data.heroes[0].descriptions.mobileVideoTitle.sections.title;
                this.ctasMobile = [
                    {
                        alt: data.heroes[0].descriptions.mobileVideoPlayCTA.sections.alt,
                        analyticsLinkId: data.heroes[0].descriptions.mobileVideoPlayCTA.sections.analyticsLinkId,
                        title: data.heroes[0].descriptions.mobileVideoPlayCTA.sections.title,
                    },
                    {
                        alt: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.alt,
                        analyticsLinkId: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.analyticsLinkId,
                        title: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.title,
                        ctaURL: data.heroes[0].descriptions.mobileVideoDetailsCTA.sections.ctaURL,
                    }
                ];
                this.titleDesktop = data.heroes[0].descriptions.videoTitle.sections.title;
                this.ctasDesktop = [
                    {
                        alt: data.heroes[0].descriptions.videoPlayCTA.sections.alt,
                        analyticsLinkId: data.heroes[0].descriptions.videoPlayCTA.sections.analyticsLinkId,
                        title: data.heroes[0].descriptions.videoPlayCTA.sections.title,
                    },
                    {
                        alt: data.heroes[0].descriptions.videoDetailsCTA.sections.alt,
                        analyticsLinkId: 'DCL_HPMP_Billboard_' +
                            data.heroes[0].descriptions.videoDetailsCTA.sections.analyticsLinkId +
                            '_Link',
                        analyticsLinkIdFullscreen: 'DCL_HPMP_InVideo_' +
                            data.heroes[0].descriptions.videoDetailsCTA.sections.analyticsLinkId +
                            '_Link',
                        title: data.heroes[0].descriptions.videoDetailsCTA.sections.title,
                        ctaURL: data.heroes[0].descriptions.videoDetailsCTA.sections.ctaURL,
                    }
                ];

                // This gets used from within the frame
                window['heroMedia'] = [{
                    type: 'video',
                    thumbnail: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    source: [
                        data.heroes[0].descriptions.videoMain.sections.source1,
                        data.heroes[0].descriptions.videoMain.sections.source2
                    ],
                    preview: [
                        data.heroes[0].descriptions.videoMain.sections.source1,
                        data.heroes[0].descriptions.videoMain.sections.source2
                    ],
                    poster: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    title: 'DCL',
                    alt: 'DCL',
                    tags: ['a']
                },
                {
                    type: 'video',
                    thumbnail: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    source: [
                        data.heroes[0].descriptions.videoDetail.sections.source1,
                        data.heroes[0].descriptions.videoDetail.sections.source2
                    ],
                    preview: [
                        data.heroes[0].descriptions.videoDetail.sections.source1,
                        data.heroes[0].descriptions.videoDetail.sections.source2
                    ],
                    poster: this.getResizeImageUrl(
                        data.heroes[0].descriptions.defaultImage.sections.source
                    ),
                    closedCaptioning: data.heroes[0].descriptions.videoDetail.sections.closedCaption,
                    descriptiveTranscript: data.heroes[0].descriptions.videoDetail.sections.descriptiveTranscript,
                    title: 'DCL',
                    alt: 'DCL',
                    tags: ['b']
                }];
            }
        });

        // TODO: replace static data
        this.id = '10007';
        this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`/features/pixie?id=${this.id}`);
        this.fullscreen = false;
        this.ME = null;

        // This gets called from within the frame
        window['initConfigOverrides'] = () => {
            this.ME = (<any>(<HTMLIFrameElement> (document.querySelector('.me-iframe'))).contentWindow).ME;
            if (this.dataType !== 'image') {
                this.ME.config.callbacks.customFullscreenEnter = () => {
                    if (!this.fullscreen && window.scrollY > 0) {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                    document.body.classList.add('pixie-fullscreen');
                    document.querySelector('pixie-hero').classList.add('fade-out-fade-in');
                    window.setTimeout(() => {
                        this.ME.changeMediaSet(2);

                        window.setTimeout(() => {
                            this.ME.fullscreenEnter();
                            this.ME.els.container.focus();
                            this.fullscreen = true;
                            document.querySelector('pixie-hero').classList.remove('fade-out-fade-in');
                        }, 200);
                    }, 700);
                };
                this.ME.config.callbacks.customFullscreenExit = () => {
                    document.body.classList.remove('pixie-fullscreen');
                    document.querySelector('pixie-hero').classList.add('fade-out-fade-in');
                    window.setTimeout(() => {
                        this.ME.changeMediaSet(1);

                        window.setTimeout(() => {
                            this.ME.fullscreenExit();
                            this.fullscreen = false;
                            document.querySelector('pixie-hero').classList.remove('fade-out-fade-in');
                        }, 200);
                    }, 700);
                };
            }
        };

        window.addEventListener('scroll', () => {
            if (this.fullscreen && window.scrollY > 50) {
                this.ME.config.callbacks.customFullscreenExit();
            }
        });
    }

    getResizeImageUrl(url) {
        const isMobile = 'ontouchstart' in window && window.screen.width < 768;
        const isValidImage = url.indexOf('.jpg') !== -1;
        const alreadyResized = url.indexOf('/resize/') !== -1;
        const version = '2';
        const compression = '75';
        let dimensions = '1280/720';
        let cdnUrl = url;

        if (isValidImage && !alreadyResized) {
            if (isMobile) {
                dimensions = window.innerWidth > 0 && window.innerWidth < 433 ?
                    window.innerWidth + '' :
                    '433';
                dimensions += '/433';
            }

            cdnUrl = cdnUrl.replace(
                '/dam/',
                `/resize/mwImage/${version}/${dimensions}/${compression}/dam/`
            );
        }

        return cdnUrl;
    }

    enterFullscreen(event) {
        event.preventDefault();

        if (!this.ME) {
            window['initConfigOverrides']();
        }

        this.ME.config.callbacks.customFullscreenEnter();
    }

}
